import axios from "axios";
import router from "@/router";
import { Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";

const BASE = "https://kxwj.cn";
// const BASE = 'http://192.168.31.148:8086';
const ROOT = `${BASE}/server`;

const instance = axios.create({
  baseURL: `${BASE}`,
  responseType: "json",
  timeout: 15000,
});

instance.interceptors.request.use(
  (config) => {
    const stateStr = window.localStorage.getItem("kxwj_vuex_state");
    if (stateStr) {
      try {
        const data = JSON.parse(stateStr);
        // 核心判断：如果存在过期时间，且当前时间已经超过了该时间
        if (data.expire && Date.now() > data.expire) {
          store.dispatch("LogOut").then(() => {
            Message({
              message: "登录状态已过期，请重新登录",
              type: "warning",
            });
            const currentPath = router.history.current.path || "";
            router.push(
              currentPath.includes("/admin") ? "/admin/login" : "/login",
            );
          });
          return Promise.reject(new Error("FRONTEND_TIMEOUT"));
        } else if (data.expire) {
          data.expire = Date.now() + 60 * 60 * 1000;
          window.localStorage.setItem("kxwj_vuex_state", JSON.stringify(data));
        }
      } catch (e) {
        console.error("解析缓存状态失败", e);
      }
    }
    if (config.url !== "/birthday/back/identifying/code/getCode") {
      config.baseURL = config.baseURL + "/server";
    }
    if (!config.url.includes("login")) {
      config.headers["Content-Type"] = "application/json;charset=utf-8";
    }
    const token = getToken();
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => {
    const res = response.data;

    // 统一处理业务报错
    if (res && res.code !== 200 && res.code !== 0) {
      Message({
        message: res.msg || "请求失败",
        type: "error",
      });
      return Promise.reject(new Error(res.msg || "Error"));
    }

    return res;
  },
  (error) => {
    // 处理 401 鉴权失败
    if (error.response && error.response.status === 401) {
      const currentPath = router.history.current.path;
      const isAdminPath = currentPath.includes("/admin");
      store.dispatch("LogOut").then(() => {
        Message({
          message: "登录状态已过期，请重新登录",
          type: "warning",
        });
        // 根据所处的系统环境跳转到对应的登录页
        router.push(isAdminPath ? "/admin/login" : "/login");
      });
    } else {
      // [优化] 处理其他 HTTP 网络状态码报错（如 500, 404 等）
      Message({
        message: error.message || "网络异常，请稍后重试",
        type: "error",
      });
    }
    return Promise.reject(error);
  },
);

// 封装自定义的快捷请求方法（保留了您特定的 GET 参数序列化逻辑）
const $ = {
  get: (url, params) => {
    if (params) {
      let queryString = "?";
      for (const propName of Object.keys(params)) {
        const value = params[propName];
        if (value !== null && typeof value !== "undefined") {
          if (typeof value === "object") {
            for (const key of Object.keys(value)) {
              let paramName = propName + "[" + key + "]";
              queryString +=
                encodeURIComponent(paramName) +
                "=" +
                encodeURIComponent(value[key]) +
                "&";
            }
          } else {
            queryString +=
              encodeURIComponent(propName) +
              "=" +
              encodeURIComponent(value) +
              "&";
          }
        }
      }
      queryString = queryString.slice(0, -1);
      url = url + queryString;
    }
    return instance.get(url);
  },

  post: (url, data) => {
    return instance.post(url, data);
  },

  put: (url, data) => {
    return instance.put(url, data);
  },

  delete: (url) => {
    return instance.delete(url);
  },
};

export default $;
export { BASE, ROOT, instance };
